// @flow

import { h }              from "preact";
import { PureComponent,
         ScrollTop }      from "shared-components";
import styles             from "./styles.scss";
import classNames         from "classnames";
import { connect }        from "preact-redux";
import Helmet             from "preact-helmet";
import { Link }           from "react-router-dom";
import { GA_CONTEXT_KEY } from "redux-enhancer-google-analytics";
import { parseParams }    from "location-search-string";
import { stutter,
         growIn,
         fadeIn,
         slideUp }        from "../../helpers/animations";

import { load   as loadOrder,
         LOADED as ORDER_LOADED } from "store-reducers/order";

import { load   as loadSerialCodes } from "../../reducers/serialcodes";


import CheckmarkIcon from "../../icons/checkmark.svg";

import Button        from "../../components/Button";
import Message       from "../../components/Message";
import ItemCodesList from "../../components/ItemCodesList";
import Wrapper       from "../../components/Wrapper";

import NotFound from "../NotFound";

const STORAGE_KEY = "registeredCheckout";

@connect(
  state => ({
    loaded          : state.order.state === ORDER_LOADED,
    obtainedCodes   : state.serialcodes.obtainedCodes,
    order           : state.order.data,
    requestedCodes  : state.serialcodes.requestedCodes,
    waitingForCodes : state.serialcodes.waitingForCodes,
  }),
  dispatch => ({
    loadOrder       : id => dispatch(loadOrder(id)),
    loadSerialCodes : () => dispatch(loadSerialCodes()),
  }),
)
export default class OrderSuccess extends PureComponent {
  static defaultProps = {
    obtainedCodes : [],
    order         : {},
  };

  state = {
    fetchingCodes: true
  };

  fetchCodeAttempt = 0;

  fetchSerialCodes = () => {
    this.props.loadSerialCodes();
    this.fetchCodeAttempt++;

    this.setState({
      fetchingCodes: this.fetchCodeAttempt < 5
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.waitingForCodes && this.state.fetchingCodes) {
      setTimeout(() => this.fetchSerialCodes(), 5000);
    }
  }

  componentWillMount() {
    const { orderId } = parseParams(this.props.location.search);

    if (!this.props.loaded) {
      this.props.loadOrder(orderId);
    }
  }

  componentDidMount() {
    const order = this.props.order;

    if (order.quote && order.quote.summary && order.quote.summary.hasVirtualItems) {
      this.fetchSerialCodes();
    }

    // TODO: Generalize and move to the google package
    if (this.context[GA_CONTEXT_KEY] && order.quote && order.quote.items) {
      if (sessionStorage && sessionStorage.getItem(STORAGE_KEY) === order.id) {
        return;
      }

      this.context[GA_CONTEXT_KEY].registerCheckoutSuccess(
        order.quote.items.map(i => ({
          id       : i.product.sku,
          name     : i.product.name,
          brand    : i.product.attributes.manufacturer,
          price    : (i.rowTotal - i.rowTax) / i.qty,
          quantity : i.qty,
        })), {
          id       : order.id,
          revenue  : order.quote.summary.grandTotalExclTax,
          tax      : order.quote.summary.tax,
          shipping : order.quote.summary.shippingAmountExclTax,
          coupon   : order.quote.summary.coupon ? order.quote.summary.coupon.ruleName : null,
      });

      if (sessionStorage) {
        try {
          sessionStorage.setItem(STORAGE_KEY, order.id);
        } catch(e) {}
      }
    }
  }

  render({ loaded, obtainedCodes, order, requestedCodes, waitingForCodes }: Props, { fetchingCodes }: any, { t }: Context) {
    if (!order.id) {
      return <NotFound />;
    }

    return (
      <div class={styles.block}>
        {loaded ?
          <div class={styles.contain}>
            <Wrapper modifiers="small">
              <header class={styles.header}>
                <div class={styles.checkmark}>
                  <CheckmarkIcon
                      class={classNames(
                        styles.checkmarkIcon,
                        growIn
                      )}
                  />
                </div>

                <div class={styles.headingArea}>
                  <h1 style={stutter(3)}
                      class={classNames(
                        styles.heading,
                        slideUp
                      )}>

                    {t("SUCCESS.HEADING")}
                  </h1>

                  <span
                      style={stutter(4)}
                      class={classNames(
                        styles.subHeading,
                        slideUp
                      )}>

                    {t("SUCCESS.ORDER_ID", { id: order.id })}
                  </span>
                </div>
              </header>

              <section class="text_row__huge">
                <ul class={styles.list}>
                  {order.quote.items.map((item, i) =>
                    <li
                        style={stutter(5 + i)}
                        class={classNames(
                          styles.item,
                          slideUp
                        )}>

                      <ItemCodesList
                          item={item}
                          obtainedCodes={obtainedCodes}
                          code={obtainedCodes.find(x => x.sku === item.product.sku)}
                          loading={fetchingCodes}
                      />

                      {!fetchingCodes && obtainedCodes.reduce((a, v) => a + v.codes.length, 0) < requestedCodes ?
                        <Message
                            status="notice"
                            class={classNames(styles.info, "row")}>

                          {t("CODES.FAILURE", { email: order.email })}
                        </Message>
                      : null}
                    </li>
                  )}
                </ul>
              </section>

              <footer class={classNames(styles.footer, "text_row__huge")}>
                <h6 style={stutter(5 + order.quote.items.length)}
                    class={slideUp}>

                  {t("SUCCESS.QUESTIONS.HEADING")}
                </h6>

                <p  style={stutter(6 + order.quote.items.length)}
                    class={slideUp}>

                  {t("SUCCESS.QUESTIONS.TEXT")}
                </p>

                <div class="text-row--large">
                  <Button
                      modifiers="ghost"
                      to={t("URL.SERVICE")}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={stutter(7 + order.quote.items.length)}
                      class={slideUp}>

                    {t("SUCCESS.QUESTIONS.LABEL")}
                  </Button>
                </div>
              </footer>
            </Wrapper>

            <Link
                to="/"
                class={styles.close}>

              {t("SUCCESS.CLOSE")}
            </Link>
          </div>
        : null}

        <ScrollTop />

        <Helmet
            title={t("SUCCESS.TITLE")}
        />
      </div>
    );
  }
}
